
<header>
    <section class="title-info">
        <h1 class="heading-1">
            {{ proteinTitle.length > 40 ? (proteinTitle | slice:0:40) + "..." : proteinTitle }}
        </h1>
          
       <div class="title-container">
            <div class="protein-name">{{ entryData().modelEntityId }}-v{{ entryData().latestVersion }}</div>
            <div class="dot">•</div>
            
            <div class="protein-name"><a target='_blank' href="/about#nav-content-6">Google Deepmind dataset</a></div>
         
            <div class="dot">•</div>
            <app-entry-status [isSummary]="true" [isProteome]="entryData().isUniProtReferenceProteome" [isReviewed]="entryData().isUniProtReviewed"></app-entry-status>
       
        </div>
    </section>
    

    <div *ngIf="(!downloadService.isSequenceDownloadRunning() || !downloadService.isDownloadRunning()) && downloadService.isDownloadFailed()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download failed due to a technical issue. Please refresh and try again." messageType="error">
        </app-status-message>
      </div>

      <div *ngIf="!downloadService.isSequenceDownloadRunning() && !downloadService.isDownloadFailed() && downloadService.isDownloadDone()"> 
        <app-status-message  (closeLinkClick)="downloadService.closeToast($event)" messageText="Download successful. <br />If the download pop-up doesn’t appear, please enable pop-ups in your browser’s Privacy and Security settings." messageType="success">
        </app-status-message>
      </div>
    
    <section class="action-buttons">
        <span style="display: inline-block; width: 20px; margin-left: 8px;" *ngIf="downloadService.isDownloadRunning() && !downloadService.isDownloadFailed() && !downloadService.isDownloadDone()">
            <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
            </svg>
        </span>
        <download-dropdown
            [isWide]="true"
            [dropdownOptions]="dropdownOptions"
            (selected)="handleSelection($event)"
            [selectedValues]="'Heatmap data'">
        </download-dropdown>
    </section>
</header>
<section class="feedback">
<p>Tell us what you think of the new look</p>

<a class="vf-button vf-button--secondary vf-button--search-pdbe" style="color: #3B6FB6"
href="https://docs.google.com/forms/d/e/1FAIpQLSd1PJBxxK7XYtvJMblnojSoykFD56P3ieeGZ7PCrRI3FtLF1Q/viewform"
target="_blank">
Share your feedback
</a>

</section>
